import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FORUM_SLUG = 'invest-uae-forum-2026';

const STYLES = `
.spkprof{background:#FAF7F0;color:#0D1B2A;min-height:100vh;font-family:Inter,system-ui,sans-serif;}
.spkprof a{color:inherit;}
.spkprof-nav{padding:24px 48px;border-bottom:1px solid rgba(200,168,75,.2);display:flex;justify-content:space-between;align-items:center;background:#fff;}
.spkprof-back{font-size:11px;font-weight:700;letter-spacing:.18em;text-transform:uppercase;color:#3A4A5C;cursor:pointer;border:none;background:none;padding:0;}
.spkprof-back:hover{color:#C8A84B;}
.spkprof-logo{font-family:'Cormorant Display',serif;font-size:22px;font-weight:700;letter-spacing:.04em;color:#C8A84B;}
.spkprof-logo em{font-style:italic;font-weight:300;color:#0D1B2A;}

/* HERO */
.spkprof-hero{padding:80px 48px 64px;background:linear-gradient(180deg,#fff 0%,#FAF7F0 100%);border-bottom:1px solid rgba(200,168,75,.2);}
.spkprof-hero-inner{max-width:1240px;margin:0 auto;display:grid;grid-template-columns:1.6fr 1fr;gap:72px;align-items:center;}
.spkprof-eyebrow{font-size:10px;font-weight:700;letter-spacing:.32em;text-transform:uppercase;color:#C8A84B;margin-bottom:18px;display:flex;align-items:center;gap:12px;}
.spkprof-eyebrow::before{content:'';display:block;width:32px;height:1px;background:#C8A84B;}
.spkprof-name{font-family:'Cormorant Display',serif;font-size:clamp(48px,5.4vw,72px);font-weight:700;line-height:1;letter-spacing:-.025em;margin:0 0 14px;}
.spkprof-name em{font-style:italic;color:#C8A84B;}
.spkprof-tagline{font-family:'Cormorant Display',serif;font-style:italic;font-weight:300;font-size:clamp(18px,1.8vw,22px);color:#3A4A5C;line-height:1.5;max-width:560px;margin:0 0 28px;}
.spkprof-meta{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:32px;}
.spkprof-pill{font-size:10px;font-weight:700;letter-spacing:.18em;text-transform:uppercase;padding:7px 14px;border-radius:50px;background:rgba(200,168,75,.08);color:#C8A84B;border:1px solid rgba(200,168,75,.32);}
.spkprof-actions{display:flex;flex-wrap:wrap;gap:12px;}
.spkprof-share{display:flex;flex-wrap:wrap;align-items:center;gap:10px;margin-top:24px;padding-top:20px;border-top:1px solid rgba(200,168,75,.18);}
.spkprof-share-label{font-size:10px;font-weight:700;letter-spacing:.22em;text-transform:uppercase;color:#7A8190;margin-right:8px;}
.spkprof-share-btn{display:inline-flex;align-items:center;font-size:11px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;padding:9px 18px;border-radius:50px;border:1px solid rgba(200,168,75,.32);background:transparent;color:#0D1B2A;text-decoration:none;cursor:pointer;transition:background .2s,color .2s,border-color .2s;}
.spkprof-share-btn:hover{background:#C8A84B;color:#0D1B2A;border-color:#C8A84B;}
.spkprof-btn{display:inline-flex;align-items:center;gap:8px;font-size:11px;font-weight:800;letter-spacing:.18em;text-transform:uppercase;padding:14px 26px;border-radius:50px;text-decoration:none;border:1px solid;cursor:pointer;transition:all .25s;}
.spkprof-btn.primary{background:#C8A84B;color:#0D1B2A;border-color:#C8A84B;}
.spkprof-btn.primary:hover{background:#0D1B2A;color:#C8A84B;}
.spkprof-btn.line{background:transparent;color:#0D1B2A;border-color:rgba(13,27,42,.2);}
.spkprof-btn.line:hover{border-color:#C8A84B;color:#C8A84B;}

/* PORTRAIT BLOCK */
.spkprof-portrait{aspect-ratio:1/1.15;background:linear-gradient(170deg,#0D1B2A 0%,#1A2F4A 60%,#0D1B2A 100%);border:1px solid rgba(200,168,75,.32);position:relative;overflow:hidden;display:flex;align-items:flex-end;padding:32px;}
.spkprof-portrait::before{content:'';position:absolute;inset:0;background-image:radial-gradient(rgba(200,168,75,.08) 1px,transparent 1px);background-size:24px 24px;opacity:.6;}
.spkprof-portrait::after{content:'';position:absolute;top:0;left:0;width:3px;height:100%;background:linear-gradient(180deg,transparent,#C8A84B 25%,#C8A84B 75%,transparent);}
.spkprof-portrait-init{font-family:'Cormorant Display',serif;font-style:italic;font-weight:700;font-size:200px;color:rgba(200,168,75,.12);line-height:1;letter-spacing:-.05em;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);user-select:none;}
/* Cutout PNG (transparent background) — anchored to bottom with drop shadow */
.spkprof-portrait-img.cutout{position:absolute;left:50%;bottom:0;transform:translateX(-50%);height:96%;width:auto;max-width:100%;object-fit:contain;object-position:bottom center;z-index:1;filter:drop-shadow(0 12px 28px rgba(0,0,0,.35));}
/* Full portrait JPG — fills the entire card edge-to-edge */
.spkprof-portrait-img.cover{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center top;z-index:1;}
.spkprof-portrait-foot{position:relative;z-index:2;color:#FAF7F0;background:linear-gradient(to top,rgba(13,27,42,.92) 0%,rgba(13,27,42,.55) 70%,transparent 100%);margin:-32px;padding:80px 32px 28px;width:calc(100% + 64px);}
.spkprof-portrait-foot-l{font-size:10px;font-weight:700;letter-spacing:.22em;text-transform:uppercase;color:#C8A84B;margin-bottom:6px;}
.spkprof-portrait-foot-h{font-family:'Cormorant Display',serif;font-size:20px;font-weight:700;color:#FAF7F0;line-height:1.2;}

/* BODY GRID */
.spkprof-body{padding:64px 48px 96px;}
.spkprof-body-inner{max-width:1240px;margin:0 auto;display:grid;grid-template-columns:1.6fr 1fr;gap:72px;}
.spkprof-section{margin-bottom:48px;}
.spkprof-section:last-child{margin-bottom:0;}
.spkprof-section-h{font-family:'Cormorant Display',serif;font-size:30px;font-weight:700;color:#0D1B2A;line-height:1.1;letter-spacing:-.02em;margin:0 0 18px;}
.spkprof-section-h em{font-style:italic;color:#C8A84B;}
.spkprof-bio{font-size:15.5px;line-height:1.8;color:#0D1B2A;}
.spkprof-bio p{margin:0 0 18px;}
.spkprof-bio p:last-child{margin-bottom:0;}

/* HIGHLIGHTS */
.spkprof-hl{display:flex;flex-direction:column;gap:14px;margin-top:8px;}
.spkprof-hl-item{display:flex;gap:14px;align-items:flex-start;font-size:14px;line-height:1.65;color:#0D1B2A;padding:18px 22px;background:#fff;border:1px solid rgba(200,168,75,.2);border-left:3px solid #C8A84B;}
.spkprof-hl-num{font-family:'Cormorant Display',serif;font-style:italic;font-weight:700;color:#C8A84B;font-size:18px;flex-shrink:0;}

/* PULL QUOTE */
.spkprof-quote{margin:36px 0 8px;padding:32px 36px;background:#fff;border-left:3px solid #C8A84B;position:relative;}
.spkprof-quote::before{content:'\\201C';position:absolute;top:-12px;left:18px;font-family:'Cormorant Display',serif;font-size:80px;line-height:1;color:#C8A84B;opacity:.55;}
.spkprof-quote-text{font-family:'Cormorant Display',serif;font-style:italic;font-size:24px;line-height:1.35;color:#0D1B2A;margin:0;letter-spacing:-.005em;}
.spkprof-quote-attr{font-size:11px;font-weight:700;letter-spacing:.22em;text-transform:uppercase;color:#7A8190;margin-top:14px;}
@media(max-width:680px){.spkprof-quote{padding:26px 22px;}.spkprof-quote-text{font-size:19px;}}

/* SIDEBAR */
.spkprof-sb{position:sticky;top:32px;align-self:start;}
.spkprof-sb-card{background:#fff;border:1px solid rgba(200,168,75,.2);padding:32px 30px;margin-bottom:24px;}
.spkprof-sb-card.gold{border-left:3px solid #C8A84B;}
.spkprof-sb-h{font-size:10px;font-weight:700;letter-spacing:.24em;text-transform:uppercase;color:#C8A84B;margin-bottom:14px;}
.spkprof-sb-talk{font-family:'Cormorant Display',serif;font-size:24px;font-weight:700;color:#0D1B2A;line-height:1.15;letter-spacing:-.01em;margin:0 0 12px;}
.spkprof-sb-meta{font-size:13px;color:#3A4A5C;line-height:1.7;}
.spkprof-sb-meta strong{color:#0D1B2A;}
.spkprof-sb-themes{list-style:none;margin:14px 0 0;padding:0;display:flex;flex-direction:column;gap:8px;}
.spkprof-sb-themes li{font-size:13px;color:#0D1B2A;line-height:1.5;display:flex;gap:10px;align-items:flex-start;}
.spkprof-sb-themes li::before{content:'';margin-top:8px;flex-shrink:0;width:5px;height:5px;background:#C8A84B;transform:rotate(45deg);}
.spkprof-sb-links{display:flex;flex-direction:column;gap:10px;}
.spkprof-sb-link{font-size:13px;color:#0D1B2A;text-decoration:none;display:flex;justify-content:space-between;align-items:center;padding:12px 0;border-bottom:1px solid rgba(200,168,75,.16);}
.spkprof-sb-link:last-child{border-bottom:none;}
.spkprof-sb-link:hover{color:#C8A84B;}
.spkprof-sb-link span:first-child{font-size:10px;font-weight:700;letter-spacing:.18em;text-transform:uppercase;color:#7A8190;}

/* RESPONSIVE */
@media(max-width:980px){
  .spkprof-hero{padding:48px 24px 40px;}
  .spkprof-hero-inner,.spkprof-body-inner{grid-template-columns:1fr;gap:36px;}
  .spkprof-portrait{max-width:360px;margin:0 auto;width:100%;}
  .spkprof-body{padding:40px 24px 64px;}
  .spkprof-sb{position:static;}
  .spkprof-nav{padding:18px 24px;}
}
`;

export default function SpeakerProfile() {
  const { speakerSlug } = useParams();
  const navigate = useNavigate();
  const [speaker, setSpeaker] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API}/events/${FORUM_SLUG}/speakers/${speakerSlug}`)
      .then((r) => setSpeaker(r.data))
      .catch((e) => setError(e?.response?.data?.detail || 'Speaker not found'));
  }, [speakerSlug]);

  useEffect(() => {
    if (speaker) {
      const fullName = speaker?.salutation && speaker?.name && !(speaker.name.toLowerCase().startsWith(speaker.salutation.toLowerCase().trim()))
    ? `${speaker.salutation} ${speaker.name}`.trim()
    : (speaker?.name || '');
      document.title = `${fullName} — Speaker · Invest UAE Forum 2026 · SKI AXIS`;
      // Set OG image meta dynamically — useful when this URL is shared post-SPA-load
      const apiOrigin = process.env.REACT_APP_BACKEND_URL || '';
      const ogImg = `${apiOrigin}/api/events/${FORUM_SLUG}/speakers/${speakerSlug}/og-card.png`;
      const setMeta = (selector, attr, value) => {
        let el = document.head.querySelector(selector);
        if (!el) {
          el = document.createElement('meta');
          const [, key, val] = selector.match(/^meta\[(\w+)="([^"]+)"\]$/) || [];
          if (key && val) el.setAttribute(key, val);
          document.head.appendChild(el);
        }
        el.setAttribute(attr, value);
      };
      setMeta('meta[property="og:image"]', 'content', ogImg);
      setMeta('meta[property="og:title"]', 'content', `${fullName} — Invest UAE Forum 2026`);
      setMeta('meta[property="og:description"]', 'content', speaker.short_bio || speaker.tagline || '');
      setMeta('meta[name="twitter:image"]', 'content', ogImg);
      setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
      // Description meta for SEO
      setMeta('meta[name="description"]', 'content', (speaker.short_bio || speaker.tagline || `${fullName} is speaking at the Invest UAE Forum 2026 — 31 May 2026, online.`));
      setMeta('meta[name="keywords"]', 'content', `${fullName}, ${speaker.role || ''}, Invest UAE Forum 2026, UAE investment forum speaker, Dubai investment event, cross-border capital UAE, ${speaker.track || ''}`.split(',').filter(Boolean).join(', '));
      // Canonical
      let linkEl = document.head.querySelector('link[rel="canonical"]');
      if (!linkEl) { linkEl = document.createElement('link'); linkEl.setAttribute('rel', 'canonical'); document.head.appendChild(linkEl); }
      linkEl.setAttribute('href', `https://skiaxis.com/forum/speakers/${speakerSlug}`);
      // JSON-LD Person structured data
      let jsonEl = document.getElementById('spk-jsonld');
      if (!jsonEl) { jsonEl = document.createElement('script'); jsonEl.id = 'spk-jsonld'; jsonEl.type = 'application/ld+json'; document.head.appendChild(jsonEl); }
      jsonEl.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Person",
        "name": fullName,
        "url": `https://skiaxis.com/forum/speakers/${speakerSlug}`,
        "image": ogImg,
        "jobTitle": speaker.role || speaker.track,
        "description": speaker.short_bio || speaker.tagline,
        "sameAs": [speaker?.links?.linkedin, speaker?.links?.website, speaker?.links?.twitter].filter(Boolean),
        "worksFor": speaker?.company ? { "@type": "Organization", "name": speaker.company } : undefined,
        "performerIn": {
          "@type": "Event",
          "name": "Invest UAE Forum 2026",
          "startDate": "2026-05-31T18:00+01:00",
          "location": { "@type": "VirtualLocation", "url": "https://skiaxis.com/events/invest-uae-forum-2026" },
        },
      });
    }
  }, [speaker, speakerSlug]);

  if (error) {
    return (
      <div className="spkprof">
        <style>{STYLES}</style>
        <div className="spkprof-nav">
          <button className="spkprof-back" onClick={() => navigate('/events/invest-uae-forum-2026')} data-testid="spkprof-back">← Back to Forum</button>
          <div className="spkprof-logo">SKI <em>AXIS</em></div>
        </div>
        <div style={{ textAlign: 'center', padding: '120px 24px' }}>
          <h1 style={{ fontFamily: "'Cormorant Display',serif", fontSize: 44 }}>{error}</h1>
          <button className="spkprof-btn line" onClick={() => navigate('/events/invest-uae-forum-2026')} style={{ marginTop: 24 }}>View All Speakers</button>
        </div>
      </div>
    );
  }

  if (!speaker) {
    return (
      <div className="spkprof">
        <style>{STYLES}</style>
        <div style={{ padding: '120px 24px', textAlign: 'center', color: '#7A8190' }}>Loading speaker profile…</div>
      </div>
    );
  }

  const fullName = speaker?.salutation && speaker?.name && !(speaker.name.toLowerCase().startsWith(speaker.salutation.toLowerCase().trim()))
    ? `${speaker.salutation} ${speaker.name}`.trim()
    : (speaker?.name || '');

  // Smart first-name extraction with optional preferred_name override
  const firstName = (() => {
    if (speaker.preferred_name) return speaker.preferred_name;
    const parts = (speaker.name || '').trim().split(/\s+/);
    const sal = (speaker.salutation || '').toLowerCase().replace(/\.$/, '');
    while (parts.length > 1) {
      const head = parts[0].toLowerCase().replace(/\.$/, '');
      if (head === sal || ['dr', 'mr', 'mrs', 'ms', 'prof', 'h.e', 'sheikh', 'h'].includes(head)) {
        parts.shift();
      } else break;
    }
    return parts[0] || speaker.name;
  })();

  return (
    <div className="spkprof" data-testid="speaker-profile-page">
      <style>{STYLES}</style>

      <div className="spkprof-nav">
        <button className="spkprof-back" onClick={() => navigate('/events/invest-uae-forum-2026')} data-testid="spkprof-back">← Forum Faculty</button>
        <div className="spkprof-logo">SKI <em>AXIS</em></div>
      </div>

      {/* HERO */}
      <section className="spkprof-hero">
        <div className="spkprof-hero-inner">
          <div>
            <div className="spkprof-eyebrow">Confirmed Speaker · Invest UAE Forum 2026</div>
            <h1 className="spkprof-name" data-testid="spkprof-name">{fullName.split(' ').slice(0, -1).join(' ')} <em>{fullName.split(' ').slice(-1)[0]}</em></h1>
            {speaker.tagline && <p className="spkprof-tagline">{speaker.tagline}</p>}
            <div className="spkprof-meta">
              {speaker.designation && <span className="spkprof-pill">{speaker.designation}</span>}
              {speaker.company && <span className="spkprof-pill">{speaker.company}</span>}
              {speaker.country && <span className="spkprof-pill">{speaker.country}</span>}
            </div>
            <div className="spkprof-actions">
              <a className="spkprof-btn primary" href="https://us06web.zoom.us/j/84373516075?pwd=9fhqBBuUJFwYQDcv0gM2drjBlV6az8.1" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }} data-testid="spkprof-reserve">Join Zoom · 31 May →</a>
              {speaker.calendly_url && (
                <a className="spkprof-btn line" href={speaker.calendly_url} target="_blank" rel="noopener noreferrer" data-testid="spkprof-book-meeting">Book a 30-min Meeting</a>
              )}
              {speaker.links?.website && <a className="spkprof-btn line" href={speaker.links.website} target="_blank" rel="noopener noreferrer" data-testid="spkprof-website">Visit Website</a>}
              {speaker.links?.linkedin && <a className="spkprof-btn line" href={speaker.links.linkedin} target="_blank" rel="noopener noreferrer" data-testid="spkprof-linkedin">LinkedIn</a>}
            </div>
            <div className="spkprof-share" data-testid="spkprof-share">
              <span className="spkprof-share-label">Share this profile</span>
              {(() => {
                // LinkedIn's crawler blocks preview/staging URLs with "Something went wrong in sharing your post".
                // Always use the public production origin for the share URL so LinkedIn can fetch the OG card cleanly.
                const PUBLIC_ORIGIN = process.env.REACT_APP_PUBLIC_SITE_ORIGIN || 'https://skiaxis.com';
                const shareUrl = `${PUBLIC_ORIGIN}/api/share/forum-speaker/${speakerSlug}`;
                const text = `${fullName} is speaking at the Invest UAE Forum 2026 — "${speaker.talk_title || speaker.track}". Sun 31 May · Live online · AED 149 entry · Investors free.`;
                const liUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
                const waUrl = `https://wa.me/?text=${encodeURIComponent(text + ' ' + shareUrl)}`;
                const xUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(shareUrl)}`;
                const copyShare = async () => {
                  try {
                    await navigator.clipboard.writeText(shareUrl);
                    const el = document.querySelector('[data-testid="spkprof-copied"]');
                    if (el) { el.textContent = 'Copied ✓'; setTimeout(() => { el.textContent = 'Copy link'; }, 1500); }
                  } catch (clipErr) {
                    console.warn('[SpeakerProfile] clipboard copy failed:', clipErr?.message);
                    const el = document.querySelector('[data-testid="spkprof-copied"]');
                    if (el) { el.textContent = 'Copy failed'; setTimeout(() => { el.textContent = 'Copy link'; }, 1500); }
                  }
                };
                return (
                  <>
                    <a className="spkprof-share-btn" href={liUrl} target="_blank" rel="noopener noreferrer" data-testid="spkprof-share-linkedin">LinkedIn</a>
                    <a className="spkprof-share-btn" href={waUrl} target="_blank" rel="noopener noreferrer" data-testid="spkprof-share-whatsapp">WhatsApp</a>
                    <a className="spkprof-share-btn" href={xUrl} target="_blank" rel="noopener noreferrer" data-testid="spkprof-share-x">X</a>
                    <button type="button" className="spkprof-share-btn" onClick={copyShare} data-testid="spkprof-copied">Copy link</button>
                  </>
                );
              })()}
            </div>
          </div>
          <div className="spkprof-portrait" data-testid="spkprof-portrait">
            {speaker.photo_cutout_url ? (
              <img
                className="spkprof-portrait-img cutout"
                src={speaker.photo_cutout_url}
                alt={fullName}
                data-testid="spkprof-portrait-img"
              />
            ) : speaker.photo_url ? (
              <img
                className="spkprof-portrait-img cover"
                src={speaker.photo_url}
                alt={fullName}
                data-testid="spkprof-portrait-img"
              />
            ) : (
              <div className="spkprof-portrait-init">{speaker.initials}</div>
            )}
            <div className="spkprof-portrait-foot">
              <div className="spkprof-portrait-foot-l">Speaking on</div>
              <div className="spkprof-portrait-foot-h">{speaker.talk_title || speaker.track}</div>
            </div>
          </div>
        </div>
      </section>

      {/* BODY */}
      <section className="spkprof-body">
        <div className="spkprof-body-inner">
          <div>
            {speaker.long_bio && (
              <div className="spkprof-section">
                <h2 className="spkprof-section-h">About <em>{firstName}</em></h2>
                <div className="spkprof-bio">
                  {speaker.long_bio
                    .replace(/\*\*(.+?)\*\*/g, '$1')   // strip **bold**
                    .replace(/(^|[\s(])\*([^*\n]+)\*(?=[\s.,;:!?)]|$)/g, '$1$2') // strip *italic*
                    .split('\n\n')
                    .map((p, i) => <p key={i}>{p}</p>)}
                </div>
                {speaker.pull_quote && (
                  <blockquote className="spkprof-quote" data-testid="spkprof-pullquote">
                    <p className="spkprof-quote-text">{speaker.pull_quote}</p>
                    <div className="spkprof-quote-attr">— {firstName}</div>
                  </blockquote>
                )}
              </div>
            )}

            {speaker.highlights?.length > 0 && (
              <div className="spkprof-section">
                <h2 className="spkprof-section-h">Career <em>Highlights</em></h2>
                <div className="spkprof-hl">
                  {speaker.highlights.map((h, i) => (
                    <div key={i} className="spkprof-hl-item" data-testid={`spkprof-hl-${i}`}>
                      <span className="spkprof-hl-num">{String(i + 1).padStart(2, '0')}</span>
                      <span>{h}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {speaker.talk_abstract && (
              <div className="spkprof-section">
                <h2 className="spkprof-section-h">Session <em>Abstract</em></h2>
                <div className="spkprof-bio"><p>{speaker.talk_abstract}</p></div>
              </div>
            )}
          </div>

          {/* SIDEBAR */}
          <aside className="spkprof-sb">
            <div className="spkprof-sb-card gold" data-testid="spkprof-sb-talk">
              <div className="spkprof-sb-h">Forum Session</div>
              <h3 className="spkprof-sb-talk">{speaker.talk_title || speaker.track}</h3>
              <div className="spkprof-sb-meta">
                <strong>Format:</strong> {speaker.talk_format || 'Keynote'}<br />
                <strong>Date:</strong> Sunday, 31 May 2026<br />
                <strong>Time:</strong> 6:00 PM BST · 9:00 PM GST · 10:30 PM IST · 1:00 PM EDT · 10:00 AM PDT<br />
                <strong>Platform:</strong> Live online (Zoom + LinkedIn)
              </div>
              {speaker.themes?.length > 0 && (
                <>
                  <div className="spkprof-sb-h" style={{ marginTop: 24 }}>Key Themes</div>
                  <ul className="spkprof-sb-themes" data-testid="spkprof-themes">
                    {speaker.themes.map((t, i) => <li key={i}>{t}</li>)}
                  </ul>
                </>
              )}
            </div>

            {speaker.calendly_url && (
              <div className="spkprof-sb-card gold" data-testid="spkprof-sb-booking">
                <div className="spkprof-sb-h">Book A Private Meeting</div>
                <h3 className="spkprof-sb-talk">30-min with <em>{firstName}</em></h3>
                <div className="spkprof-sb-meta" style={{ marginBottom: 18 }}>
                  Discuss governance architecture, cross-border capital deployment, or your UAE entry strategy — directly with {firstName}.
                </div>
                <a className="spkprof-btn primary" href={speaker.calendly_url} target="_blank" rel="noopener noreferrer" data-testid="spkprof-sb-book-btn" style={{ width: '100%', justifyContent: 'center' }}>
                  Open Calendly →
                </a>
              </div>
            )}

            {(speaker.links?.linkedin || speaker.links?.website || speaker.links?.twitter || speaker.links?.instagram) && (
              <div className="spkprof-sb-card">
                <div className="spkprof-sb-h">Connect</div>
                <div className="spkprof-sb-links">
                  {speaker.links.linkedin && (
                    <a className="spkprof-sb-link" href={speaker.links.linkedin} target="_blank" rel="noopener noreferrer" data-testid="spkprof-sb-linkedin">
                      <span>LinkedIn</span><span>↗</span>
                    </a>
                  )}
                  {speaker.links.website && (
                    <a className="spkprof-sb-link" href={speaker.links.website} target="_blank" rel="noopener noreferrer" data-testid="spkprof-sb-website">
                      <span>Website</span><span>↗</span>
                    </a>
                  )}
                  {speaker.links.twitter && (
                    <a className="spkprof-sb-link" href={speaker.links.twitter} target="_blank" rel="noopener noreferrer" data-testid="spkprof-sb-twitter">
                      <span>X / Twitter</span><span>↗</span>
                    </a>
                  )}
                  {speaker.links.instagram && (
                    <a className="spkprof-sb-link" href={speaker.links.instagram} target="_blank" rel="noopener noreferrer" data-testid="spkprof-sb-instagram">
                      <span>Instagram</span><span>↗</span>
                    </a>
                  )}
                </div>
              </div>
            )}
          </aside>
        </div>
      </section>
    </div>
  );
}
